import { ParsersPanel } from "../../../api/ParsersPanel";
import { useSourceStats } from "./useSourceStats";

export function useArabicSources(days = 7, threshold?: number) {
  return useSourceStats(ParsersPanel.getArabicSources, days, threshold);
}
